const SWITCH_RESET = 'SWITCH_RESET';
const SWITCH_STATE = 'SWITCH_STATE';
const SWITCH_SPEED = 'SWITCH_SPEED';

export const switchReset = () => ({ type: SWITCH_RESET });

export const editSwitchState = value => ({
  type: SWITCH_STATE,
  value
});

export const editSwitchSpeed = value => ({
  type: SWITCH_SPEED,
  value
});

const initialState = {
  switchState: false,
  switchSpeed: 2
};

export default function switchButtonReducer(state = initialState, action) {
  switch (action.type) {
    case SWITCH_RESET:
      return initialState;
    case SWITCH_STATE:
      return {
        ...state,
        switchState: action.value
      };
    case SWITCH_SPEED:
      return {
        ...state,
        switchSpeed: action.value
      };
    default:
      return state;
  }
}
